module.exports = __webpack_public_path__ + "static/media/cardtree.592a6a09.jpg";